import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { TeamQuarterlyPlanDto } from '../types';

type Params = {
  year: number;
  quarter: number;
  plan: string;
  isBonusActive?: boolean;
  bonusManager?: number | null;
};

const updateTeamQuarterlyPlan = async ({
  year,
  quarter,
  plan,
  isBonusActive,
  bonusManager,
}: Params) => {
  const { data } = await api.post<TeamQuarterlyPlanDto>(
    `${PANEl_BASE_URL}/general/quarterly-plan/create_by_params/`,
    {
      year,
      quarter,
      plan,
      is_bonus_active: isBonusActive ?? false,
      bonus_manager: bonusManager ?? null,
    }
  );

  return data;
};

export const useUpdateTeamQuarterlyPlan = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateTeamQuarterlyPlan,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
